import { createSlice } from "@reduxjs/toolkit";

export const stepper = createSlice({
  name: "stepper",
  initialState: {
    isStepValid: false,
  },
  reducers: {
    setSteperValidation: (state, { payload }) => {
      state.isStepValid = payload;
    },
  },
});

export const { setSteperValidation } = stepper.actions;

export const stepperReducer = stepper.reducer;
